import React, {FC} from 'react';
import "./style.scss";

type WithAnimationProps = {
    children: React.ReactNode
};

const WrapperAnimation: FC<WithAnimationProps> = ({children}) => {
    return (
        <div className="animated fadeIn">
            {children}
        </div>
    );
};

export default WrapperAnimation;
